"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginType = exports.SEND_MSG_STATUS = exports.QRCODE_STATUS = exports.MERGE_LOGIN_TYPE = exports.LOGIN_USE_TYPE = exports.LOGIN_TYPE_MAP = exports.LOGIN_TYPE = exports.LOGIN_STATUS = exports.DEFAULT_USE_TYPE = exports.BIX_TYPE = exports.BID_PW_OVERSEAS = exports.BID_PW = exports.BID_MSG = exports.BALANCE_STR = void 0;
var _cookie = _interopRequireDefault(require("../utils/cookie"));
var _valid = require("./valid");
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @Author: liujunhong
 * @Date: 2022/9/24
 * @Desc: 登录相关常量
 */

// 海外账密登录
var BID_PW_OVERSEAS = 'xyyo9z0v402a';
// 账密登录
exports.BID_PW_OVERSEAS = BID_PW_OVERSEAS;
var BID_PW = 'nxewxjp8on51';
exports.BID_PW = BID_PW;
var BID_MSG = 'uldohnn0zmpi';
exports.BID_MSG = BID_MSG;
var LOGIN_TYPE = 'Community';
// 登录状态
exports.LOGIN_TYPE = LOGIN_TYPE;
var LOGIN_STATUS = {
  /**
   * 需要验证码
   */
  needCaptcha: 'needCaptcha',
  /**
   * 验证码错误
   */
  captchaError: 'captchaError',
  /**
   * 需要实名
   */
  realNameError: 'realNameError'
};
// 验证码发送状态
exports.LOGIN_STATUS = LOGIN_STATUS;
var SEND_MSG_STATUS = {
  /**
   * 发送成功
   */
  sendSuccess: 'partial_send_success',
  /**
   * 成功
   */
  success: 'success',
  /**
   * 未达到下次发送时间
   */
  timeFailed: 'forbidden-temporarily',
  /**
   * 次数太多
   */
  numFailed: 'suspect-sourcetype',
  /**
   * 获取信息失败
   */
  infoFailed: 'get-smsInfo-failed'
};
// 短信登录balanceCode
exports.SEND_MSG_STATUS = SEND_MSG_STATUS;
var BALANCE_STR = 'balanceCode';
// 二维码状态
exports.BALANCE_STR = BALANCE_STR;
var QRCODE_STATUS = {
  /**
   * 准备完毕
   */
  ok: 'qrcode_gen',
  /**
   * 扫码成功
   */
  success: 'success',
  /**
   * 超时
   */
  timeout: 'qrcode_timeout',
  /**
   * 需要实名
   */
  realNameError: 'realNameError',
  /**
   * 账号异常
   */
  failed: 'failure',
  /**
   * 超时
   */
  timeUp: 'qrcode_timeup',
  /**
   * 验证成功
   */
  scanned: 'qrcode_scan'
};
exports.QRCODE_STATUS = QRCODE_STATUS;
var BIX_TYPE = {
  /**
   * 登录
   */
  NL: 'NL',
  /**
   * 修改密码
   */
  MC: 'MC',
  /**
   * 找回密码
   */
  FC: 'FC',
  /**
   * 海外登录
   */
  NLH: 'NLH'
};
// 登录方式
exports.BIX_TYPE = BIX_TYPE;
var LOGIN_TYPE_MAP = {
  DEFAULT: 'DefaultLogin',
  WE_GAME: 'WeGameLogin',
  MERGE: 'MergeLogin'
};
exports.LOGIN_TYPE_MAP = LOGIN_TYPE_MAP;
var MERGE_LOGIN_TYPE = {
  GY: 'gy',
  TENCENT: 'tencent'
};
exports.MERGE_LOGIN_TYPE = MERGE_LOGIN_TYPE;
var getLoginType = function getLoginType() {
  var cookie = _cookie.default.get('GyyxLoginType');
  return cookie === 'wegame';
};
exports.getLoginType = getLoginType;
var DEFAULT_USE_TYPE = 'default';
exports.DEFAULT_USE_TYPE = DEFAULT_USE_TYPE;
var LOGIN_USE_TYPE = {
  default: {
    tab: {
      pw: '密码登录',
      msg: '短信登录',
      qrcode: '二维码'
    },
    bizType: BIX_TYPE.NL,
    accountRules: _valid.ACCOUNT_RULES,
    bId: BID_PW,
    registerUrl: _index.REGISTER_URL,
    forgetPwdUrl: _index.FORGET_PASSWORD_URL,
    maxLength: 16
  },
  overseas: {
    tab: {
      pw: '密码登录',
      qrcode: '二维码'
    },
    bizType: BIX_TYPE.NLH,
    accountRules: _valid.ACCOUNT_RULES_OVERSEAS,
    bId: BID_PW_OVERSEAS,
    registerUrl: _index.REGISTER_OVERSEAS_URL,
    forgetPwdUrl: _index.FORGET_PASSWORD_OVERSEAS_URL,
    maxLength: 18
  }
};
exports.LOGIN_USE_TYPE = LOGIN_USE_TYPE;